import {
  GameApp,
  PaginationQueryArg,
  PaginationResult,
  Walkthrough,
} from 'lib/_types'
import { pathApiGamesApps, pathApiWalkthroughs } from 'lib/paths'

import { yayApi } from '../baseApi'
import { LOAD_NUMBER_SMALL } from 'config'

export const walkthroughApi = yayApi
  .enhanceEndpoints({
    addTagTypes: ['Games/Apps', 'Games/Walkthrough'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getGameApp: build.query<GameApp, { id: number }>({
        query: ({ id }) => ({
          url: pathApiGamesApps,
          params: {
            ids: id,
            number: 1,
          },
        }),
        transformResponse: (baseQueryReturnValue) => {
          return baseQueryReturnValue?.games?.[0] || {}
        },
      }),

      getGamesApps: build.query<
        PaginationResult<GameApp>,
        PaginationQueryArg<{}>
      >({
        providesTags: ['Games/Apps'],
        query: ({ number = LOAD_NUMBER_SMALL, from = undefined }) => ({
          url: pathApiGamesApps,
          params: {
            number,
            from_id: from,
          },
        }),
        transformResponse: (baseQueryReturnValue) => {
          return {
            list: baseQueryReturnValue?.games || [],
            next_page_value: baseQueryReturnValue?.from_id,
          }
        },
      }),

      getWalkthroughs: build.query<Array<Walkthrough>, { appId: number }>({
        providesTags: ['Games/Walkthrough'],
        queryFn: async ({ appId }, _, __, baseQuery) => {
          const result = await baseQuery({
            url: pathApiWalkthroughs({ appId }),
            method: 'GET',
          })

          if (result?.error?.status === 404) {
            return {
              data: [],
            }
          }

          return result
        },
      }),
    }),
    overrideExisting: false,
  })

export const {
  useGetWalkthroughsQuery,
  useGetGamesAppsQuery,
  useGetGameAppQuery,
} = walkthroughApi
